module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-700-b5ee3da2876c44c6d7d2d6bac0cdba0b.woff";